import cx from 'classnames';
import styles from '../TestDriveCenter.module.css';

const stroke = 'var(--cvna-blue)';

const iconProps = {
  className: 'mb-[22px] block',
  fill: 'none',
  height: 40,
  stroke,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeWidth: 1.7,
  viewBox: '0 0 48 48',
  width: 40
} as const;

const valueProps = [
  {
    heading: 'Transparent pricing',
    icon: (
      <svg {...iconProps}>
        <line x1="24" x2="24" y1="13" y2="35" />
        <path d="M29 19c0-2.2-2.2-3.5-5-3.5s-5 1.3-5 3.3c0 4.6 10 2.7 10 7.4 0 2.1-2.2 3.5-5 3.5s-5-1.4-5-3.6" />
        <path
          d="M24 6.5v3M24 38.5v3M37 11l-2.1 2.1M13.1 34.9 11 37M41.5 24h-3M9.5 24h-3M37 37l-2.1-2.1M13.1 13.1 11 11"
          opacity="0.5"
        />
      </svg>
    ),
    text: "Zero doc fees, no hidden fees. See what you'll pay up front."
  },
  {
    heading: 'Stress-free test drive',
    icon: (
      <svg {...iconProps}>
        <ellipse cx="24" cy="11" opacity="0.5" rx="10" ry="2.4" />
        <path d="M9 31l2.2-6.2A4 4 0 0 1 15 22h18a4 4 0 0 1 3.8 2.8L39 31" />
        <path d="M7 31h34v3.2a1.8 1.8 0 0 1-1.8 1.8H8.8A1.8 1.8 0 0 1 7 34.2V31Z" />
        <circle cx="15" cy="33" r="2.3" />
        <circle cx="33" cy="33" r="2.3" />
      </svg>
    ),
    text: 'No upselling, take it for a spin before you commit.'
  },
  {
    heading: 'Buy from anywhere',
    icon: (
      <svg {...iconProps}>
        <rect height="32" rx="3" width="16" x="16" y="8" />
        <path d="M20.5 23.5l2.7 2.7 5-5.4" />
      </svg>
    ),
    text: "Buy from our store, or from your couch. We'll deliver it to your driveway."
  },
  {
    heading: '7-Day Money-Back Guarantee',
    icon: (
      <svg {...iconProps}>
        <path d="M24 7l13 4.5v8.2c0 8.1-5.3 15.2-13 17.8-7.7-2.6-13-9.7-13-17.8V11.5L24 7Z" />
        <text
          fill={stroke}
          fontFamily="var(--font-sans)"
          fontSize="11"
          fontWeight="800"
          stroke="none"
          textAnchor="middle"
          x="24"
          y="21.5"
        >
          7
        </text>
        <text
          fill={stroke}
          fontFamily="var(--font-sans)"
          fontSize="6"
          fontWeight="700"
          letterSpacing="0.5"
          stroke="none"
          textAnchor="middle"
          x="24"
          y="30"
        >
          DAY
        </text>
      </svg>
    ),
    text: "Try it for a week. If it's not the right fit, we'll take it back, no questions asked."
  }
];

export default function TestDriveCenterValueProps() {
  return (
    <section className="relative z-[1] overflow-visible bg-[var(--cvna-navy)] px-[clamp(20px,4vw,56px)] py-[clamp(64px,10vh,128px)]">
      <div
        aria-hidden
        className={cx(
          styles.valuePropsGlow,
          'pointer-events-none absolute left-1/2 top-1/2 h-[min(1100px,130vh)] w-[min(1600px,150vw)] -translate-x-1/2 -translate-y-1/2 rounded-full'
        )}
      />
      <div
        className={cx(
          styles.valuePropsSash,
          'relative mx-auto max-w-[1200px] rounded-[22px] border border-[#e2e8f0] bg-white'
        )}
      >
        <div className="grid grid-cols-4 px-[clamp(20px,2vw,32px)] py-[clamp(40px,4vw,56px)] max-[920px]:grid-cols-2 max-[920px]:gap-x-0 max-[920px]:gap-y-40">
          {valueProps.map(({ heading, icon, text }) => (
            <div
              key={heading}
              className={cx(
                styles.valueProp,
                styles.animIn,
                'px-[clamp(20px,2.4vw,40px)] max-[920px]:px-[clamp(16px,4vw,28px)]'
              )}
            >
              {icon}
              <h3 className="mb-[11px] text-[19px] font-bold leading-[1.25] text-[var(--cvna-navy-ink)]">
                {heading}
              </h3>
              <p className="m-0 max-w-[230px] text-[14.5px] font-normal leading-[1.55] text-[var(--cvna-slate)]">
                {text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
